export interface ResourceModuleItem {
    name: string;
    display_name: string;
    description: string;
    for_admin?: number;
    for_user?: number;
}

export interface ResourceModuleGroup {
    title: string;
    modules: ResourceModuleItem[];
}

// Cấu trúc các Group và Module bên trong quản lý tài nguyên
export const RESOURCE_MODULE_GROUPS: ResourceModuleGroup[] = [
    {
        title: 'QUẢN LÝ TÀI NGUYÊN',
        modules: [
            { name: 'resourceStatistics', display_name: 'Thống kê tài nguyên', description: 'Hiển thị menu Thống kê tài nguyên ở Quản lý tài nguyên' },
            { name: 'resourceAssetManage', display_name: 'Quản lý tài nguyên', description: 'Hiển thị menu Quản lý tài nguyên' },
            { name: 'displayManage', display_name: 'Quản lý hiển thị', description: 'Hiển thị menu Quản lý hiển thị' },
            { name: 'requestApproval', display_name: 'Quản lý phê duyệt', description: 'Hiển thị menu Quản lý phê duyệt' },
        ],
    },
    {
        title: 'QUẢN LÝ HIỆN VẬT',
        modules: [
            { name: 'assetLibrary', display_name: 'Thư viện hiện vật', description: 'Hiển thị menu Thư viện hiện vật/tài liệu' },
            { name: 'loanManage', display_name: 'Quản lý phiếu mượn', description: 'Hiển thị menu Quản lý phiếu mượn' },
            { name: 'loanCart', display_name: 'Giỏ mượn', description: 'Hiển thị menu Giỏ mượn' },
            { name: 'trackDeliveryStatus', display_name: 'Theo dõi tình trạng bàn giao', description: 'Hiển thị menu Theo dõi tình trạng bàn giao' },
        ],
    },
    {
        title: 'QUẢN LÝ KHO',
        modules: [
            { name: 'warehouseManage', display_name: 'Quản lý kho & bảo quản', description: 'Hiển thị menu Quản lý kho & bảo quản' },
        ],
    },
    {
        title: 'NÂNG CAO',
        modules: [
            { name: 'aiAgent', display_name: 'AI Agent', description: 'Hiển thị menu AI Agent trong Quản lý tài nguyên' },
        ],
    },
    {
        title: 'QUẢN LÝ BÁO CÁO',
        modules: [
            { name: 'reportTemplateManage', display_name: 'Tạo và lưu mẫu báo cáo', description: 'Hiển thị menu Tạo và lưu mẫu báo cáo' },
            { name: 'reportSummaryPrint', display_name: 'In báo cáo tổng hợp', description: 'Hiển thị menu In báo cáo tổng hợp' },
        ],
    },
];

// Danh sách các module thuộc quản lý tài nguyên (dùng làm gợi ý khi thêm thủ công)
export const RESOURCE_MODULES_SUGGESTIONS: ResourceModuleItem[] = RESOURCE_MODULE_GROUPS.flatMap((g) => g.modules);

// Tên các module thuộc quản lý tài nguyên (dùng để lọc)
export const RESOURCE_MODULE_NAMES: string[] = RESOURCE_MODULES_SUGGESTIONS.map((rm) => rm.name);
